import type {BioIconProps} from './common-types'

export function ReturnProcessIcon({...attributes}: BioIconProps) {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M19.8334 12.5C19.8334 11.2681 19.787 10.047 19.6958 8.8384C19.5461 6.85425 17.9791 5.28724 15.995 5.13757C14.7864 5.04641 13.5653 5 12.3334 5C11.1015 5 9.88037 5.04641 8.67178 5.13757C6.68762 5.28724 5.12061 6.85425 4.97095 8.8384C4.95434 9.05852 4.93922 9.27906 4.9256 9.5M19.8334 12.5L22.8334 9.5M19.8334 12.5L16.8334 9.5M4.83337 12.5C4.83337 13.7319 4.87978 14.953 4.97095 16.1616C5.12061 18.1458 6.68762 19.7128 8.67178 19.8624C9.88037 19.9536 11.1015 20 12.3334 20C13.5653 20 14.7864 19.9536 15.995 19.8624C17.9791 19.7128 19.5461 18.1458 19.6958 16.1616C19.7124 15.9415 19.7275 15.7209 19.7411 15.5M4.83337 12.5L7.83337 15.5M4.83337 12.5L1.83337 15.5"
        stroke="#030303"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
